import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

const IconDot: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconDoc" {...props}>
    <svg height="100%" width="32" viewBox="0 0 32 32" fill="currentColor">
      <circle cx="16" cy="16" r="3" />
    </svg>
  </IconSVG>
)

export default IconDot
